import { Modal } from "@/shared/ui";

type Props = {
  onClose: () => void;
};

export default function AuthServerRulesModal({ onClose }: Props) {
  return (
    <Modal open onClose={onClose} title="Правила сервера “Server_Name”">
      <div className="flex flex-col gap-2.5">
        <div className="text-16 text-accent font-bold">Общие условия</div>
        <p className="text-15 text-white font-medium">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto atque commodi molestiae
          animi adipisci cupiditate, nulla aut laborum distinctio enim labore officiis soluta
          deserunt harum laboriosam veniam, est, illum qui. Explicabo nobis quasi animi? Molestias
          earum harum, iusto recusandae suscipit aperiam neque aliquid. Tempore reiciendis, natus
          cumque eos at dicta dolore est, aperiam nisi sequi minus! Cum, laboriosam eligendi.
          Doloribus? Reiciendis odit accusamus nisi cum, soluta dolor aspernatur iusto voluptatum
          nemo nostrum ipsa deleniti ullam fugit facilis, repudiandae atque cupiditate temporibus
          exercitationem vel explicabo est! Earum, ab. Dignissimos, sint unde. Ipsa aut sed enim,
          obcaecati repellat quis soluta fugiat qui pariatur. Cumque voluptatum officiis voluptates
          sequi quo quidem quasi perspiciatis sunt impedit minus esse aliquam assumenda natus,
          dolores enim at. Quo quidem fuga saepe necessitatibus nesciunt ut! Sunt quas perferendis
          quae, qui esse, doloribus, delectus iure necessitatibus dignissimos minima dolorum atque
          repellendus maiores. Quibusdam earum voluptatibus accusantium, asperiores saepe sapiente!
          Expedita modi molestiae sequi ex ad, eum a minima itaque iusto illum blanditiis quod eaque
          earum quibusdam architecto laborum inventore molestias numquam labore rem vitae! Illo
          veniam vel sequi ex. Recusandae adipisci rerum voluptatem, sequi eligendi voluptatum
          blanditiis laudantium culpa nam autem, veniam consequatur ipsa iusto maiores corporis
          dolore excepturi iure odio? Deserunt optio unde consequatur. Laborum eaque aliquid
          praesentium! Quae explicabo ea odio, minima consequatur adipisci, fugiat quaerat
          perspiciatis eligendi, corrupti in nulla quod doloribus accusantium hic consequuntur.
          Ducimus saepe quae quibusdam veniam officia tenetur reiciendis blanditiis modi ipsum.
          Deleniti dignissimos, doloremque voluptatibus culpa ab ipsa, quis tempore sint, rem optio
          sequi voluptatum ratione maiores deserunt? Consectetur voluptate sit optio incidunt ab
          vel, molestias delectus iusto quidem nihil consequuntur. Quisquam provident voluptate
          magni placeat quis quasi alias odio officiis cumque facilis fugit eligendi ducimus cum ab,
          velit, temporibus nesciunt consequuntur dignissimos quas aut reprehenderit magnam! Minima
          quisquam quo fugit.
        </p>
      </div>
    </Modal>
  );
}
